"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const WinstonContext_1 = require("../context/WinstonContext");
function useWinstonLogger() {
    const { logger } = react_1.default.useContext(WinstonContext_1.getWinstonContext());
    if (!logger) {
        throw new Error('No Winston logger instance can be found. Please ensure that you ' +
            'have called `WinstonProvider` higher up in your tree.');
    }
    return logger;
}
exports.default = useWinstonLogger;
//# sourceMappingURL=useWinstonLogger.js.map